"use strict";

/**
 * Build type, one of `"full"`, `"light"` or `"minimal"`.
 * @name build
 * @type {string}
 * @const
 */
exports.build = "minimal";

// Serialization
exports.Writer       = require(15);
exports.BufferWriter = require(16);
exports.Reader       = require(2);
exports.BufferReader = require(3);

// Utility
exports.util         = require(12);
exports.rpc          = require(5);
exports.roots        = require(4);
exports.configure    = configure;

/* istanbul ignore next */
/**
 * Reconfigures the library according to the environment.
 * @returns {undefined}
 */
function configure() {
    exports.util.LongBits._configure(exports.util.Long);
    exports.Writer._configure(exports.BufferWriter);
    exports.Reader._configure(exports.BufferReader);
}

// Set up buffer utility according to the environment
configure();
